<template>
  <div id="normal-header">
    <nav class="navbar transparent">
      <div class="navbar-brand" :class="{'transparent': data.transparent}">
        <div
          v-on:click="toggleBurger"
          v-bind:class="{'is-active':isActive, 'navbar-burger':!isActive}"
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
      <div
        class="navbar-menu"
        v-bind:class="{'is-active': isActive, 'transparent': data.transparent}"
        id="navMenu"
      >
        <div class="navbar-start"></div>
        <div class="navbar-end" v-on:click="deactivate">
          <router-link :to="homeRoute" class="navbar-item mobile-logo is-hidden-desktop">
            <img :src="logo" alt="Logo Eveniment" />
          </router-link>
          <div v-for="(item, index) in routes" :key="index">
            <router-link
              class="navbar-item"
              :to="item.path.ro"
              v-if="!item.hasChildren"
              :class="{'current-page': $route.path==item.path.ro && $route.name!='registration', 'register-button': item.name=='Înregistrare', register: $route.name=='registration' && item.name=='Înregistrare'}"
            >{{item.name}}</router-link>
            <div class="navbar-item has-dropdown is-hoverable" v-if="item.hasChildren">
              <a class="navbar-link">{{index}}</a>
              <div class="navbar-dropdown">
                <div v-for="subroute in item.subroutes" :key="item.subroutes.indexOf(subroute)">
                  <router-link :to="subroute.path.ro" class="navbar-item">{{subroute.name}}</router-link>
                  <hr
                    class="navbar-divider"
                    v-if="item.subroutes.indexOf(subroute) !== item.subroutes.length - 1"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="background"></div>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
import routes from "@/assets/resources/routes.js";
import pathPrefix from "@/pathPrefix.js";

export default {
  props: ["data"],
  data() {
    return {
      routes,
      pathPrefix,
      homeRoute: "",
      registerRoute: "",
      isActive: false,
      logo: require("@/assets/images/logo.png"),
      // activeRoute: '',
      // activeRoutes: [false, false, false]
    };
  },
  // watch:{
  //   $route: function (to, from){
  //       // console.log(to.name);
  //       // console.log(from);
  //       this.activeRoute = to.path;
  //       this.routes.forEach((route, index) => {
  //         // console.log(route.path.ro);
  //         if(route.path.ro === to.path) {
  //           this.activeRoutes[index] = true;
  //         } else {
  //           this.activeRoutes[index] = false;
  //         }
  //       })
  //       // console.log(this.activeRoutes);
  //   }
  // },
  // computed:{
  //   isActiveRoute: function (route){
  //     return {
  //       "active-link": route === this.activeRoute
  //     }

  //   }
  // },
  methods: {
    toggleBurger: function () {
      this.isActive = !this.isActive;
    },
    deactivate: function () {
      this.isActive = false;
    },
    changeLocale: function (lang) {
      this.$i18n.locale = lang;
    },
  },
  created() {
    this.homeRoute = `${pathPrefix}/`;
    this.registerRoute = `${pathPrefix}/register`;
  },
};
</script>
<style lang="scss" scoped>
@import "./headers.scss";
</style>



